import React, { Component } from "react";
import { Redirect } from 'react-router-dom';
import axios from 'axios';
import  WebServiceList  from '../../webservices/WebServiceList'
import BlueButton from "../common/BlueButton"
import {
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  FormInput,
  FormTextarea
  
} from "shards-react";


export default class NouveauMessage extends Component {

  constructor(props) {

    super(props);
    this.onChangeMessageTitle = this.onChangeMessageTitle.bind(this);
    this.onChangeMessageDescription = this.onChangeMessageDescription.bind(this);

    this.onSubmit = this.onSubmit.bind(this);
    this.state = {
      title: this.props.title,
      message_title: "",
      message_description: "",
      redirect: false
    }

  }



  onChangeMessageTitle(e) {
    this.setState({
      message_title: e.target.value
    });
  }

  onChangeMessageDescription(e) {
    this.setState({
      message_description: e.target.value
    });
  }

  onSubmit(e) {
    e.preventDefault();

    console.log(`Button submitted:`);
    let usersId = [];
    let theUserId = localStorage.getItem("userId");
    usersId.push(theUserId);

    const newMessage = {
      usersIds: usersId,
      title: this.state.message_title,
      description: this.state.message_description
    };
    
    let theToken = localStorage.getItem("token");
    const headers = {
      'Content-Type': 'application/json',
      'x-access-token': theToken,
    };

    console.log("New Message:" + JSON.stringify(newMessage))

    axios.post(WebServiceList.WsSendMessage(), newMessage, {headers: headers})
      .then(res => {
        console.log(res.data);
        this.setState({
          redirect: true
        })

        this.props.messageSentCallback();

      });

    this.setState({
      message_title: '',
      message_description: ''

    })
  }

  renderRedirect = () => {
    if (this.state.redirect) {
      return <Redirect to='/user-messages' />
    }
  }

  render() {
    return (<Card small className="h-100">
      {/* Card Header */}
      <CardHeader className="border-bottom">
        <h6 className="m-0">{this.state.title}</h6>
      </CardHeader>

      <CardBody className="d-flex flex-column">
        <Form className="quick-post-form" onSubmit={this.onSubmit}>
          {/* Title */}
          {this.renderRedirect()}
          <FormGroup>
            <FormInput placeholder="Titre du message"
              value={this.state.message_title}
              onChange={this.onChangeMessageTitle} />
          </FormGroup>

          {/* Body */}
          <FormGroup>
            <FormTextarea placeholder="Descriptif du message..."
              value={this.state.message_description}
              onChange={this.onChangeMessageDescription}
            />
          </FormGroup>

          {/* Create Draft */}
          <FormGroup className="mb-0">
            <BlueButton theme="accent" type="submit">
              Envoyer
          </BlueButton>
          </FormGroup>
        </Form>
      </CardBody>
    </Card>)
  }
}

